import type React from 'react';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { Movement } from '#src/app/pages/petitionDetails/shared/types';

import { MovementCard } from './components/MovementCard';

type Props = {
	movement: Movement;
	alwaysExpanded?: boolean;
};

export const MovementContainer: React.FC<Props> = (props) => {
	const {
		data: {
			petition: { id: petitionId },
		},
	} = usePetitionDetailsPageData();
	return <MovementCard petitionId={petitionId} {...props} />;
};
